var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("search", {
        attrs: {
          categories: this.category,
          types: this.types,
          filters: this.search_filters,
        },
        on: {
          searchType: function ($event) {
            return _vm.changeFilter($event)
          },
        },
      }),
      _vm._v(" "),
      this.user.user_categories.length === 0 &&
      this.search_filters.default === "user"
        ? _c("div", [
            _c(
              "div",
              { staticClass: "alert alert-danger", attrs: { role: "alert" } },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.__("search.paragraph.no_interests")) +
                    " "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "/member/profiles/" + this.user.username + "/edit",
                    },
                  },
                  [_vm._v(_vm._s(_vm.__("globals.click_here")))]
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row match-height pl-05 pr-05 mt-2 pb-1" },
        _vm._l(_vm.products, function (product, index) {
          return _c(
            "div",
            {
              key: _vm.infiniteId + index,
              staticClass: "col-4 col-md-3 col-lg-2 pl-05 pr-05",
            },
            [
              _c("products-infinite-scroll-card", {
                attrs: {
                  product: product,
                  service_settings: _vm.service_settings,
                },
              }),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "infinite-loading",
        {
          attrs: { identifier: _vm.infiniteId },
          on: {
            distance: function ($event) {
              1
            },
            infinite: _vm.infiniteHandler,
          },
        },
        [
          _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "no-results" }, slot: "no-results" }, [
            _vm._v(" " + _vm._s(_vm.__("globals.no_products_found"))),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }